import { IComponentOptions } from "angular";
import { UserDetailController } from "./controller";

export const vsComponentName = "userDetail";

export const userDetailComponentOptions: IComponentOptions = {
  controller: UserDetailController,
  controllerAs: "userDetailController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    user: "<",
  },
};
